import React, { useState, useEffect } from "react";
import { Modal, Button, Input, message, Form } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SuccessMail from "./SuccessMail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const GenerateProposalSendMail = ({
  visible,
  onClose,
  id,
  name,
  route,
  title,
  buttonTitle,
}) => {
  const [mailSent, setMailSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [ccmail, setCcmail] = useState([]);
  const [additionlEmail, setAdditionalEmail] = useState();

  console.log(name, "name in generate proposal send mail");
  console.log(route, "route in generate proposal send mail");
  console.log(id, "id in generate proposal send mail");

  const handleAddtoCC = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (emailRegex.test(additionlEmail)) {
      setCcmail([...ccmail, additionlEmail]);
      setAdditionalEmail("");
      return true;
    } else {
      message.error("Invalid email");
    }
  };
  const handleRemovefromCC = (email) => {
    let remainingEmails = ccmail.filter((e) => e !== email);
    setCcmail(remainingEmails);
  };
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (visible) {
      if (name == "proposal") {
        axios
          .get(`${apiUrl}/api/setting/getSetting`)
          .then((response) => {
            setCcmail(response.data.proposal_cc);
            // Initialize the message field with the fetched data
            form.setFieldsValue({ message: response.data.proposal_email });
          })
          .catch((error) => {
            console.error("Failed to fetch setting data:", error);
          });
      } else if (name == "invoice") {
        axios
          .get(`${apiUrl}/api/setting/getSetting`)
          .then((response) => {
            setCcmail(response.data.invoice_cc);
            // Initialize the message field with the fetched data
            form.setFieldsValue({ message: response.data.invoice_email });
          })
          .catch((error) => {
            console.error("Failed to fetch setting data:", error);
          });
      } else {
        axios
          .get(`${apiUrl}/api/setting/getSetting`)
          .then((response) => {
            setCcmail(response.data.agreement_cc);
            // Initialize the message field with the fetched data
            form.setFieldsValue({ message: response.data.agreement_email });
          })
          .catch((error) => {
            console.error("Failed to fetch setting data:", error);
          });
      }
    }
  }, [visible]);

  console.log(ccmail);

  const handleGoTo = () => {
    if (buttonTitle == "Go to Proposal") {
      navigate("/proposal");
    } else if (buttonTitle == "Go to Invoice") {
      navigate("/invoice");
    } else {
      navigate("/agreement");
    }
  };

  const handleSuccessMailClose = () => {
    setMailSent(false);
  };

  const handleSendMail = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        axios
          .post(`${apiUrl}/api/${name}/${route}/${id}`, {
            to: values.email,
            message: values.message,
            cc: ccmail,
          })
          .then((response) => {
            setLoading(false);
            setMailSent(true);
            message.success("Mail sent successfully");
            onClose();
          })
          .catch((error) => {
            setLoading(false);
            message.error("Failed to send mail");
          });
      })
      .catch((errorInfo) => {
        console.error("Validate Failed:", errorInfo);
      });
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onClose}
        footer={null}
        centered
        closable={true}
        className="acc-modal"
      >
        <div>
          <div
            className="text-center align-middle font-medium text-xl title-div bg-blue-50 p-4"
            style={{ boxShadow: "0 4px 2px -2px lightgrey" }}
          >
            {title}
          </div>

          <div className="px-12 py-4" style={{ backgroundColor: "#F6FAFB" }}>
            <div className="text-center font-medium text-xl mb-5 rounded-md">
              Send Mail
            </div>
            {/* <p className="text-green-50 font-bold mb-4">
              Document generated successfully
            </p> */}

            <Form form={form} layout="vertical">
              <Form.Item
                label="Mail ID"
                name="email"
                rules={[{ required: true, message: "Please enter the email" }]}
              >
                <Input
                  type="email"
                  placeholder="Enter the Mail ID of client"
                  className="w-full p-2 border rounded"
                />
              </Form.Item>

              <p className="text-gray-600 ">CC's Mails:</p>
              {ccmail.length > 0 && (
                <p className="text-gray-600 mb-4 ">
                  {ccmail.map((email, index) => (
                    <span
                      key={index}
                      className="text-blue-600 border border-blue-600 px-[0.5rem] py-[0.25rem] rounded-[4px] mr-[0.25rem]"
                    >
                      {email}{" "}
                      <span
                        className="text-red-500 cursor-pointer"
                        onClick={() => handleRemovefromCC(email)}
                      >
                        X
                      </span>
                    </span>
                  ))}
                </p>
              )}
              <div className="flex items-center gap-x-[1rem]">
                <Input
                  type="email"
                  placeholder="Enter the Mail ID to CC Others"
                  className="w-full p-2 border rounded"
                  value={additionlEmail}
                  onChange={(e) => setAdditionalEmail(e.target.value)}
                />
                <button
                  type="button" // Use a button element for better semantics and accessibility
                  className="
      whitespace-nowrap 
      border border-buttonModalColor 
      text-buttonModalColor 
      bg-none 
      p-2 
      rounded 
      h-[38px]
      hover:bg-buttonModalColor 
      hover:text-white 
      transition-colors
    "
                  onClick={handleAddtoCC}
                >
                  + ADD
                </button>
              </div>
              <p className="text-gray-600 mb-4">
                Note: This mail will be sent to CCs also. You can edit in
                Settings.
              </p>
              <Form.Item
                label="Message"
                name="message"
                rules={[
                  { required: true, message: "Please enter the message" },
                ]}
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={form.getFieldValue("message") || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    form.setFieldsValue({ message: data });
                  }}
                />
              </Form.Item>
              <div className="flex justify-center">
                <Button
                  type="primary"
                  onClick={handleSendMail}
                  loading={loading}
                  className="mr-4 border border-buttonModalColor text-white bg-buttonModalColor rounded px-6 py-4 flex items-center justify-center"
                >
                  Send Mail
                </Button>
                <button
                  onClick={handleGoTo}
                  className="border border-buttonModalColor text-buttonModalColor bg-none p-1 rounded"
                >
                  {buttonTitle}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>

      {mailSent && (
        <SuccessMail
          visible={mailSent}
          email={form.getFieldValue("email")}
          title={title}
          onCloseSuccess={handleSuccessMailClose}
        />
      )}
    </>
  );
};

export default GenerateProposalSendMail;
